import React, { useState } from "react";
import { Formik, useFormikContext } from "formik";
import { Switch } from "@headlessui/react";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import CustomFilterInput from "../../../../shared/CustomFilterInput";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
function IsAccident({ onChange, refId }) {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
  } = useFormikContext();
  const { t, i18n } = useTranslation();
  const accidentTypes = [
    { id: 1, name: t("Motor Vehicle Accident") },
    { id: 2, name: t("School Accident") },
    { id: 3, name: t("Sporting Accident") },
    { id: 4, name: t("Workplace Accident") },
  ];
  const countries = [
    { id: 1, name: t("Afganistan") },
    { id: 2, name: t("Saudia Arabia") },
    { id: 3, name: t("Pakistan") },
    { id: 4, name: t("UAE") },
    { id: 5, name: t("India") },
  ];

  const subTypes = [{ id: 1, name: "OutPatient" }];

  const addData = (values) => {
    // setShowEligibilityModal(false);
    let data = _.cloneDeep(values);
    console.log("data :: ", data);
    // checkEligibility({ variables: { input: data } });
  };

  const formikRef = React.useRef();
  React.useImperativeHandle(refId, () => ({
    Submit: async () => {
      await formikRef.current.submitForm();
    },
  }));

  function watchForm(data) {
    if (onChange) {
      onChange({
        values: data,
      });
    }
  }

  return (
    <div className="personal-data !p-2 !mb-2">
      <div className="personal-title !mb-2">
        <div className="inventory-svg">
          <svg
            width="26"
            height="26"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="34" height="34" rx="8" fill="#F4F6F8"></rect>
            <path
              d="M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z"
              fill="#0070c2"
            ></path>
            <path
              d="M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z"
              fill="#0070c2"
            ></path>
          </svg>
        </div>
        <div className="w-full flex items-center justify-between">
          <span className="font-semibold text-gray-800">{t("Accident")}</span>
          <div className="flex space-x-3 md:mt-0 md:ml-4 mr-2">
            <Switch
              checked={values.is_accident}
              onChange={() => setFieldValue("is_accident", !values.is_accident)}
              className="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-[#0070c2] focus:ring-offset-2"
            >
              <span className="sr-only">{t("Use setting")}</span>
              <span
                aria-hidden="true"
                className="pointer-events-none absolute h-full w-full rounded-md bg-white"
              />
              <span
                aria-hidden="true"
                className={classNames(
                  values.is_accident ? "!bg-[#0070c2]" : "bg-gray-200",
                  "pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out"
                )}
              />
              <span
                aria-hidden="true"
                className={classNames(
                  values.is_accident ? "translate-x-6" : "translate-x-0",
                  "pointer-events-none absolute left-0 inline-block h-4 w-4 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out"
                )}
              />
            </Switch>
          </div>
        </div>
      </div>
      {values.is_accident && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1.5">

          <CustomFilterInput
            label={t("Accident Type")}
            name="accidentType"
            isSelect={true}
            options={accidentTypes}
            value={values.accidentType}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={t("Select Accident Type")}
            error={errors.accidentType}
            touched={touched.accidentType}
          />

          <CustomFilterInput
            label={t("Street")}
            name="street"
            value={values.street}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={t("Street Name")}
            error={errors.street}
            touched={touched.street}
          />

          <CustomFilterInput
            label={t("City")}
            name="city"
            value={values.city}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={t("Enter City Name")}
            error={errors.city}
            touched={touched.city}
          />
          <CustomFilterInput
            label={t("State")}
            name="state"
            value={values.state}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={t("Enter State/Province")}
            error={errors.state}
            touched={touched.state}
          />

          <CustomFilterInput
            label={t("Country")}
            name="country"
            isSelect={true}
            options={countries}
            value={values.country}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={t("Select Country")}
            error={errors.country}
            touched={touched.country}
          />
          <CustomFilterInput
            label={t("Date")}
            name="date"
            type="date"
            value={values.date}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.date}
            touched={touched.date}
          />
        </div>
      )}
    </div>
  );
}

export default IsAccident;
